<template>
    <div class="website-tool-body">
        <div 
            class="website-tool-card" 
            v-for="(item, index) in tools" 
            :key="index" 
            @click="toWebsite(item)"
            @contextmenu="openContextMenu($event, item, index)"
        >
            <el-tooltip class="item" effect="light" :content="item.name" placement="bottom" v-if="item.name.length > 6" open-delay="300">
                <img :src="item.favicon" onerror="this.onerror=null;this.src='https://emc.b-tronsemi.com/favicon.ico';" alt="Image">
            </el-tooltip>
            <img :src="item.favicon" onerror="this.onerror=null;this.src='https://emc.b-tronsemi.com/favicon.ico';" alt="Image" v-else>
            <div class="website-tool-title">{{ item.name.length > 6 ? item.name.substring(0, 4) + '..' : item.name }}</div>
        </div>

        <div v-if="contextMenuVisible" 
             :style="{ top: contextMenuPosition.y + 'px', left: contextMenuPosition.x + 'px' }" 
             class="context-menu">
            <ul>
                <li class="el-icon-paperclip" @click="toWebsite(selectedTool.item)">新标签页打开</li>
                <li class="el-icon-edit" @click="editTool">编辑</li>
                <li class="el-icon-delete" @click="deleteTool">删除</li>
            </ul>
        </div>

        <div class="el-icon-plus website-tool-add website-tool-item" @click="clickAdd"></div>
        <el-dialog :title="dialog.title" :visible.sync="dialog.visit" :close-on-click-modal="false" width="50%">
            <el-form :model="dialog.form" :rules="rules" label-width="100px" ref="websiteForm">
                <el-form-item label="网站名称" prop="name">
                    <el-input v-model="dialog.form.name" placeholder="请输入网站名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="网址" prop="url">
                    <el-input v-model="dialog.form.url" placeholder="请输入网址" clearable></el-input>
                </el-form-item>
                <el-form-item label="在线图标地址" prop="favicon">
                    <el-input v-model="dialog.form.favicon" placeholder="请输入在线图标地址" clearable></el-input>
                </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="submit">提 交</el-button>
                <el-button @click.native="dialog.visit = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { websiteTools } from './websiteTools.js'

export default {
    data() {
        return {
            tools: [],
            dialog: {
                'visit': false,
                'form': {
                    'name': '',
                    'url': '',
                    'favicon': ''
                }
            },
            rules: {
                name: [
                    {required: true, message: '请输入网站名称', trigger: 'blur'},
                ],
                url: [
                    {required: true, message: '请输入网址', trigger: 'blur'},
                ],
            },
            contextMenuVisible: false,
            contextMenuPosition: { x: 0, y: 0 },
            selectedTool: null,
        };
    },
    created() {
        this.initTools();
    },
    methods: {
        initTools() {
            const toolsStr = localStorage.getItem('EMC_WEBSITE_TOOL');
            if (toolsStr !== null) {
                this.tools = JSON.parse(toolsStr);
            } else {
                this.tools = websiteTools;
            }
        },
        clickAdd() {
            this.dialog = {
                'visit': true,
                'title': '添加',
                'form': {
                    'name': '',
                    'url': '',
                    'favicon': '',
                }
            };
        },
        submit() {
            this.$refs.websiteForm.validate((valid) => {
                if (valid) {
                    const url = new URL(this.dialog.form.url);
                    if (this.dialog.form.favicon === '' || this.dialog.form.favicon === undefined) {
                        this.dialog.form.favicon = url.origin + '/favicon.ico';
                    }
                    if (this.dialog.title === '添加') {
                        this.tools.push(this.dialog.form);
                    } else {
                        this.tools[this.selectedTool.index] = this.dialog.form
                    }
                    localStorage.setItem('EMC_WEBSITE_TOOL', JSON.stringify(this.tools));
                    this.dialog.visit = false;
                    this.$notify.success(`${this.dialog.title}成功`);
                }
            });
        },
        toWebsite(item) {
            window.open(item.url);
        },
        openContextMenu(event, item, index) {
            event.preventDefault();
            this.selectedTool = { item, index };
            this.contextMenuPosition = { x: event.clientX + 120, y: event.clientY + 60 };
            this.contextMenuVisible = true;
        },
        editTool() {
            const { item, index } = this.selectedTool;
            this.dialog = {
                'visit': true,
                'form': { ...item },
                'title': '修改',
            };
            this.contextMenuVisible = false;
        },
        deleteTool() {
            const { index } = this.selectedTool;
            this.tools.splice(index, 1);
            localStorage.setItem('EMC_WEBSITE_TOOL', JSON.stringify(this.tools));
            this.contextMenuVisible = false;
            this.$notify.success('删除成功');
        },
        closeContextMenu() {
            this.contextMenuVisible = false;
        },
        searchByName(name) {
            if (name === '' || name === undefined) {
                this.initTools()
                return;
            }
            const regExp = new RegExp(name, 'i')
            const tools = this.tools.filter(item => item.name.match(regExp))
            if (!tools.length) {
                window.open(`https://cn.bing.com/search?form=QBLH&q=${name}`);
            } else {
                this.tools = tools
            }
        }
    }
}

</script>

<style lang="scss" scoped>
.website-tool-body {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .website-tool-add {
        background-color: white;
        font-size: 50px;
        margin-top: 10px;
        margin: 20px 15px 15px 15px;
        border-radius: 15px;
        cursor: pointer;
        width: 75px;
        height: 75px;
        text-align: center;
        line-height: 75px;
        transform: translateY(0px);
        transition: all 0.3s ease;
    }

    .website-tool-add:hover {
        transform: translateY(-6px);
    }

    .website-tool-card {
        border-radius: 5px;
        margin: 15px;
        width: 80px;
        height: 96px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: translateY(0px);
        transition: all 0.3s ease;

        img {
            width: 64px;
            height: 64px;
            border-radius: 15px;
            background-color: white;
            border: solid 1px #29a2ce;
        }

        .website-tool-title {
            width: 120%;
            text-align: center;
            font-size: 15px;
            margin-top: 8px;
            color: #fff;
        }
    }

    .website-tool-card:hover {
        transform: translateY(-6px);
    }
    
    .context-menu {
        position: absolute;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        width: 150px;

        box-shadow: #00000080 0 10px 30px;
        border-radius: 12px;
        padding: 4px;
        background-color: #0b0b0bb3;
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, .16);

        ul {
            margin: 0;
            padding: 5px 0;
            list-style: none;
        }

        li {
            width: 140px;
            transition: #ffffff26 .2s;
            font-size: 20px;
            line-height: 30px;
            color: #fff;
            padding: 0 4px;
            cursor: pointer;
            margin: 4px 0;
            border-radius: 6px;
        }

        li:hover {
            background-color: #ffffff26;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/classify/websiteTool.vue